import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FileText, PlusCircle, ShoppingBag } from 'lucide-react'
import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import AsyncSelect from 'react-select/async'
import { toast } from 'react-toastify'
import blingImg from '../../assets/bling.png'
import { Ask } from '../../components/Ask/index.jsx'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner'
import ListaProdutos from '../../components/ListaProduto/listaproduto'
import Navbar from '../../components/navbar/navbar'
import { useProducts } from '../../hooks/useProducts/index.js'
import apinode from '../../services/apinode'
import BlingService from '../../services/database/BlingService/index.js'
import CategoriesService from '../../services/database/CategoriesService/index.js'
import SubcategoriesService from '../../services/database/SubcategoriesService/index.js'
import { gerarRelatorioUltimosDias } from '../../utils/relatorios/relatorioUltimosDias.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { unifyParams } from '../../utils/unifyParams.js'
import AtualizarEstoqueModal from './modalEstoque.jsx'
import { ModalExpLeroy } from './ModalExpLeroy/index.jsx'
import MovimentacaoEstoqueModal from './modalmov.jsx'
import './styles.css'

export function Produtos() {
  const [busca, setBusca] = useState('')
  const [texto, setTexto] = useState('')
  const [products, setProducts] = useState([])
  const [buscarProdutosComposicao, setBuscarProdutosComposicao] =
    useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [selectedOption, setSelectedOption] = useState('APELIDO')
  const [selectedMarktPlaces, setSelectedMarktplaces] = useState([])
  const [showExportModal, setShowExportModal] = useState(false)
  const [isProductsLoading, setIsProductsLoading] = useState(false)
  const [isLoadingProduct, setIsLoadingProduct] = useState(true)
  const [showUpdateStockModal, setShowUpdateStockModal] = useState(false)
  const [selectedSku, setSelectedSku] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [historicoMov, setHistoricoMov] = useState([])
  const [nomeProduto, setNomeProduto] = useState('')

  const [ValueSelecionado, setSelecionadoValor] = useState('')
  const [retornodedados, setRetornoDados] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [marktPlace, setMartkPlace] = useState('')
  const [composicao, setComposicao] = useState([])
  const [showComposicao, setShowComposicao] = useState(false)
  const [marcas, setMarcas] = useState([])
  const [selectedMarca, setSelectedMarca] = useState('')
  const [categorias, setCategorias] = useState([])
  const [subcategorias, setSubcategorias] = useState([])
  const [selectCategoria, setSelectCategoria] = useState('')
  const [selectSubcategoria, setSelectSubcategoria] = useState('')
  const [daysOfSales, setDaysOfSales] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isRequestBlingLoading, setIsRequestBlingLoading] = useState(false)

  const productSelected = useProducts()

  const handleMarcaChange = (event) => {
    setSelectedMarca(event.target.value)
  }

  const handleComposicao = async (item) => {
    try {
      const response = await apinode.get(
        `/custos/listacomposicao/${item}/${localStorage.idconta}`,
      )
      setComposicao(response.data)
      setShowComposicao(true)
    } catch (error) {
      console.error('Erro ao buscar composições:', error)
      return []
    }
  }

  async function loadCategorias() {
    try {
      const data = await CategoriesService.getAll()

      setCategorias(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as categorias!')
    }
  }

  async function loadSubcategorias() {
    try {
      const data = await SubcategoriesService.getAll()

      setSubcategorias(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as subcategorias!')
    }
  }

  const ProductModal = ({ show, handleClose, composicao }) => {
    const calcularCustoMedio = (composicao) => {
      let total = 0
      let quantidadeTotal = 0

      composicao.forEach((item) => {
        if (item.qtestger > 0 && item.precocusto > 0) {
          total += item.qtestger * item.precocusto
          quantidadeTotal += item.qtestger
        }
      })
      if (quantidadeTotal === 0) return 0

      return (total / quantidadeTotal).toFixed(2)
    }

    let custoMedio = 0

    if (composicao.some((item) => item.qtestger > 0)) {
      custoMedio = calcularCustoMedio(composicao)
    }

    if (composicao.length > 0) {
      custoMedio = calcularCustoMedio(composicao)
    }

    return (
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Composição</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            striped
            bordered
            hover
          >
            <thead>
              <tr>
                <th>SKU</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Preço de Custo</th>
                <th>Preço Venda</th>
                <th>atualização</th>
              </tr>
            </thead>
            <tbody>
              {composicao.length === 0 ? (
                <tr>
                  <td colSpan="4">Produto sem composição</td>
                </tr>
              ) : (
                composicao.map((item) => (
                  <tr key={item.sku}>
                    <td>{item.sku}</td>
                    <td>{item.descricao}</td>
                    <td>{item.qtestger}</td>
                    <td>
                      {localStorage.admin === 'SIM' &&
                        item.precocusto.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                    </td>
                    <td>
                      {item.precovenda.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                    <td>
                      <Link
                        to={`/produtos/${item.codproduto}`}
                        className="btn btn-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          title="Editar"
                        />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
              {custoMedio > 0 && localStorage.admin === 'SIM' && (
                <tr>
                  <td
                    style={{ color: 'blue', fontFamily: 'Arial' }}
                    colSpan="3"
                  >
                    Custo Médio
                  </td>
                  <td style={{ color: 'blue', fontFamily: 'Arial' }}>
                    {custoMedio}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <p
            style={{
              color: 'black',
              fontFamily: 'Arial',
              padding: '10px',
              backgroundColor: '#f0f0f0',
              borderRadius: '5px',
            }}
          >
            Custo médio é calculado somando o custo de cada item ao estoque
            positivo.
          </p>
        </Modal.Body>
      </Modal>
    )
  }

  // Modals Leroy
  const [isModalExpLeroyOpen, setIsModalExpLeroyOpen] = useState(false)

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleInputBlur = () => {
    // Converter o valor para um número e arredondar para duas casas decimais
    const roundedValue = parseFloat(inputValue).toFixed(2)

    // Atualizar o estado com o valor arredondado
    setInputValue(roundedValue)

    // Lógica adicional a ser executada quando o input perder o foco
  }

  async function handleClonar(item) {
    return await Ask(
      'Tem certeza de que deseja clonar este produto?',
      async () => {
        try {
          setIsProductsLoading(true)

          const response = await apinode.get(
            `/estoque/clonar/${item}/${localStorage.idconta}`,
          )

          toast.success(
            `Produto clonado com sucesso com SKU ${response.data.sku}`,
          )

          await fetchProductsAll()
        } catch (error) {
          setError(error)
          toast.error('Falha ao clonar')
        } finally {
          setIsProductsLoading(false)
        }
      },
    )
  }

  const handleExportarProdutosMercadoLivre = async () => {
    if (marktPlace === 'Magalu') {
      try {
        const response = await apinode.post(
          `/magalu/product/${selectedOption}/${selectedSku}/${localStorage.idconta}`,
          {
            category_id: ValueSelecionado,
            precovenda: inputValue,
          },
        )
        toast.success('Produto exportado com sucesso!')
        setRetornoDados(response.data.produto)
      } catch (error) {
        setError(error)
        toast.error('Falha ao exportar')
      }
    } else {
      try {
        const response = await apinode.post(
          `/exportml/itemmercadolivre/${selectedOption}/${selectedSku}/${localStorage.idconta}`,
          {
            category_id: ValueSelecionado,
            precovenda: inputValue,
          },
        )
        toast.success('Produto exportado com sucesso!')
        setRetornoDados(response.data.produto)
      } catch (error) {
        setError(error)
        toast.error('Falha ao exportar')
      }
    }
  }

  const handleSelectChange = (selectedValues) => {
    setSelecionadoValor(selectedValues?.value)
  }

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const produto = {
    nome: nomeProduto, // Substitua pelo nome do seu produto
  }

  const fetchHistoryMov = async (item) => {
    try {
      setIsProductsLoading(true)
      const response = await apinode.get(
        `/estoque/mov/${item}/${localStorage.idconta}`,
      )
      setHistoricoMov(response.data)
      handleOpenModal()
    } catch (error) {
      setError(error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const loadOptions = async (inputValue, callback) => {
    try {
      // Fazer chamada à sua API para buscar opções usando Axios
      const response = await apinode.get(
        `/exportml/domaindiscovery/${inputValue}/${selectedOption}/${localStorage.idconta}`,
      )
      const data = response.data

      // Mapear dados para o formato esperado pelo react-select
      const options = data.map((item) => ({
        value: item.category_id,
        label: item.domain_name,
      }))

      // Chamar o callback com as opções encontradas
      callback(options)
    } catch (error) {
      console.error('Erro ao buscar opções da API:', error)
      callback([])
    }
  }

  const handleMovProd = async (item, nomeprod) => {
    fetchHistoryMov(item)
    //handleOpenModal();
    setNomeProduto(nomeprod)
  }

  const buttonSearchRef = useRef(null)
  const navigate = useNavigate()

  const clickExport = async (Item, ValorProd, NomeProd) => {
    setShowExportModal(true)
    setSelectedSku(Item)
    setInputValue(ValorProd)
    setNomeProduto(NomeProd)
  }

  async function handleImportProduct() {
    try {
      setIsRequestBlingLoading(true)

      const responseMessage = await BlingService.importProduct(selectedSku)

      toast.success(responseMessage)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível concluir a exportação!')
    } finally {
      setIsRequestBlingLoading(false)
    }
  }

  const clickAjustStock = async (item) => {
    setSelectedSku(item)
    setShowUpdateStockModal(true)
  }

  const handleCloseExportModal = () => {
    setShowExportModal(false)
  }

  const handleButtonClick = () => {
    setBusca(texto)
    fetchProducts(localStorage.idconta, texto)
  }

  async function fetchProductsAll() {
    setIsLoadingProduct(true)

    try {
      const response = await apinode.get(
        `/estoque/${localStorage.idconta}?idusuario=${localStorage.idusuario}`,
      )

      setProducts(response.data)
    } catch (error) {
      sendErrorApiMessage(error, 'Erro ao buscar produtos!')
    } finally {
      setIsLoadingProduct(false)
    }
  }

  async function fetchRelatorio90dias() {
    setIsProductsLoading(true)
    try {
      const skus =
        productSelected.productsToExport.length > 0
          ? productSelected.productsToExport.map((product) => product.SKU)
          : products.map((product) => product.SKU)

      const response = await apinode.post(
        `/relatorios/90dias/${localStorage.idconta}`,
        { skus, daysOfSales },
      )

      setIsModalOpen(false)
      gerarRelatorioUltimosDias(daysOfSales, response.data)
    } catch (error) {
      setError(error)
      toast.error('Erro ao buscar produtos, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchMarcas() {
    setIsProductsLoading(true)

    try {
      const response = await apinode.get(
        `/estoque/marca/${localStorage.idconta}`,
      ) // Realiza a solicitação GET

      setMarcas(response.data)
    } catch (error) {
      setError(error)
      toast.error('Erro ao buscar marcas, Resposta:', error)

      // Em caso de erro, também defina o isLoading como false
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchProducts(conta, sku) {
    try {
      setIsProductsLoading(true)

      const url = unifyParams(`/estoque/lista-produto`, [
        {
          key: 'conta',
          value: conta,
        },
        {
          key: 'sku',
          value: sku,
        },
        {
          key: 'idusuario',
          value: localStorage.idusuario,
        },
        {
          key: 'categoria',
          value: selectCategoria,
        },
        {
          key: 'subcategoria',
          value: selectSubcategoria,
        },
        {
          key: 'marca',
          value: selectedMarca,
        },
        {
          key: 'composicao',
          value:
            buscarProdutosComposicao && buscarProdutosComposicao ? 'S' : 'N',
        },
      ])

      const response = await apinode.get(url)
      setProducts(response.data)
      setError(null)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar produtos')
      setError(err)
      setProducts([])
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchContas(conta) {
    try {
      // Construa a URL com os parâmetros
      const url = `lojasvirtuais/${conta}`

      const response = await apinode.get(url) // Realiza a solicitação GET
      setSelectedMarktplaces(response.data)
      setIsLoading(false)
    } catch (error) {
      setError(error)
      setIsLoading(false)
    }
  }

  async function confirmDeleteUser(id) {
    setIsProductsLoading(true)

    try {
      // Realiza a solicitação DELETE para deletar o produto com o ID específico
      await apinode.delete(`/estoque/${localStorage.idconta}/${id}`)
      fetchProductsAll()
      toast.success('Produto deletado com sucesso!')
    } catch (error) {
      setError(error)
      toast.error('Erro ao deletar produto, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const handleSelect = (selectedKey, event) => {
    const selectedID_CONTA = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).ID_CONTA

    const selectedMarkPlace = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).ID_CONTA
    setSelectedOption(selectedID_CONTA)

    const plataforma = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).PLATAFORMA

    setMartkPlace(plataforma)
  }

  function handleModalSubmit() {
    fetchRelatorio90dias()
  }

  function handleOpenModalLeroy() {
    setIsModalExpLeroyOpen(true)
  }

  useEffect(function () {
    fetchContas(localStorage.idconta)
    fetchProductsAll()
    fetchMarcas()
    loadCategorias()
    loadSubcategorias()
  }, [])

  return (
    <div>
      <Navbar />
      <div className="mt-page">
        <div
          className="align-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
          }}
        >
          <h1
            style={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: '#333',
              margin: 0,
            }}
          >
            Produtos
          </h1>

          <div style={{ display: 'flex', gap: '12px' }}>
            {/* Botão Relatório (azul) */}
            <button
              onClick={() => setIsModalOpen(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                backgroundColor: '#007bff',
                border: 'none',
                padding: '8px 14px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#fff',
                transition: 'background-color 0.2s ease',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#0069d9')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = '#007bff')
              }
            >
              <FileText size={18} />
              <span>Gerar Relatório</span>
            </button>

            {/* Botão Leroy Merlin (verde) */}
            <button
              title="Exportar Produtos LM"
              onClick={handleOpenModalLeroy}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                backgroundColor: '#3d960a',
                border: 'none',
                padding: '8px 14px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#fff',
                transition: 'background-color 0.2s ease',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#327c08')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = '#3d960a')
              }
            >
              <ShoppingBag size={18} />
              <span>Exportar LM</span>
            </button>

            {/* Botão Adicionar (turquesa) */}
            <button
              title="Adicionar"
              onClick={() => navigate('/produtos/novo')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                backgroundColor: '#17a2b8',
                border: 'none',
                padding: '8px 14px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#fff',
                transition: 'background-color 0.2s ease',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#138496')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = '#17a2b8')
              }
            >
              <PlusCircle size={20} />
              <span>Adicionar</span>
            </button>
          </div>
        </div>

        <div className="row mt-10">
          <div className="col-8">
            <div className="input-group mb-3">
              <input
                type="text"
                value={texto}
                onChange={(e) => setTexto(e.target.value)}
                className="form-control"
                placeholder="Pesquisar por sku ou descrição"
                aria-describedby="button-addon2"
                onKeyUp={(e) =>
                  e.key === 'Enter' && buttonSearchRef.current?.click(e)
                }
              />
              <button
                ref={buttonSearchRef}
                onClick={handleButtonClick}
                className="btn btn-primary"
                type="button"
                id="button-addon2"
                disabled={isProductsLoading}
              >
                <i className="fas fa-search"></i>

                <span>
                  {isProductsLoading ? 'Pesquisando...' : 'Pesquisar'}
                </span>
              </button>
            </div>
          </div>
        </div>

        <Row
          className="mb-4"
          xs={4}
        >
          <Col>
            <select
              className="form-select form-select-sm"
              aria-label="Small select example"
              value={selectedMarca}
              onChange={handleMarcaChange}
            >
              <option value="">Selecione uma marca</option>
              {marcas.map((marca) => (
                <option
                  key={marca.ID_MARCA}
                  value={marca.ID_MARCA}
                >
                  {marca.DESC_MARCA}
                </option>
              ))}
            </select>
          </Col>

          <Col>
            <select
              className="form-select form-select-sm"
              aria-label="Small select example"
              value={selectCategoria}
              onChange={(e) => setSelectCategoria(e.target.value)}
            >
              <option value="">Selecione uma categoria</option>
              {categorias.map((categoria) => (
                <option
                  key={categoria.id_categoria}
                  value={categoria.id_categoria}
                >
                  {categoria.categoria}
                </option>
              ))}
            </select>
          </Col>

          <Col>
            <select
              className="form-select form-select-sm"
              aria-label="Small select example"
              value={selectSubcategoria}
              onChange={(e) => setSelectSubcategoria(e.target.value)}
            >
              <option value="">Selecione uma subcategoria</option>
              {subcategorias.map((subcategoria) => (
                <option
                  key={subcategoria.id_subcategoria}
                  value={subcategoria.id_subcategoria}
                >
                  {subcategoria.subcategoria}
                </option>
              ))}
            </select>
          </Col>

          <Col>
            <Form.Check
              label="Com Composição"
              checked={buscarProdutosComposicao}
              onChange={() =>
                setBuscarProdutosComposicao((prevState) => !prevState)
              }
            />
          </Col>
        </Row>

        <Card>
          <Card.Body
            style={{
              height: 1000,
            }}
          >
            {!error && isProductsLoading ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CustomSpinner />
              </div>
            ) : (
              <ListaProdutos
                busca={busca}
                isLoadingProduct={isLoadingProduct}
                texto={texto}
                arrayClientes={products}
                clickDelete={confirmDeleteUser}
                clickExport={clickExport}
                clickAjustStock={clickAjustStock}
                clickMovProd={handleMovProd}
                clickClonar={handleClonar}
                clickComposicao={handleComposicao}
              />
            )}
          </Card.Body>
        </Card>

        <AtualizarEstoqueModal
          show={showUpdateStockModal}
          handleClose={() => setShowUpdateStockModal(false)}
          SkuAtualizar={selectedSku}
        />

        {/* Modal de exportação */}
        <Modal
          show={showExportModal}
          onHide={handleCloseExportModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Exportar Produtos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p>{nomeProduto}</p>
            </div>

            <Row>
              <Col>
                <p>Buscar opção na API</p>

                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadOptions}
                  onChange={handleSelectChange}
                  className="mb-3"
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <p>Valor do anúncio</p>

                <input
                  type="text"
                  placeholder="Digite um valor"
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  className="form-control"
                />
              </Col>

              <Col>
                <p>Conta destino</p>

                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                  >
                    {selectedOption}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {selectedMarktPlaces.map((item) => (
                      <Dropdown.Item
                        key={item.ID_CONTA}
                        eventKey={item.APELIDO}
                      >
                        {item.APELIDO}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>

            <div className="mt-4">
              <div style={{ marginBottom: '10px' }}>
                <img
                  src={retornodedados.thumbnail}
                  alt={retornodedados.title}
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  {retornodedados.title}
                </h3>
              </div>
              <div>
                <a
                  href={retornodedados.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: 'none',
                    color: '#007bff',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  Ir para o Produto
                </a>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomButton
              onClick={handleCloseExportModal}
              isDelete
            >
              Fechar
            </CustomButton>

            <OverlayTrigger overlay={<Tooltip>Exportar para o Bling</Tooltip>}>
              <CustomButton
                color="#001b0e"
                onClick={handleImportProduct}
                isLoading={isRequestBlingLoading}
              >
                <img
                  src={blingImg}
                  alt="Bling Logo"
                  style={{
                    width: 55,
                  }}
                />
              </CustomButton>
            </OverlayTrigger>

            <Button
              variant="primary"
              onClick={handleExportarProdutosMercadoLivre}
            >
              Exportar
            </Button>
          </Modal.Footer>
        </Modal>

        <MovimentacaoEstoqueModal
          produto={produto}
          showModal={showModal}
          handleClose={handleCloseModal}
          historico={historicoMov}
        />

        <ModalExpLeroy
          isOpen={isModalExpLeroyOpen}
          onClose={() => setIsModalExpLeroyOpen(false)}
        />
      </div>

      <div>
        <Modal
          show={isModalOpen}
          onHide={() => setIsModalOpen(false)}
        >
          <Modal.Header>
            <Modal.Title>Dias de Venda</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              value={daysOfSales}
              onChange={(e) => setDaysOfSales(e.target.value)}
              placeholder="Dias de Venda"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setIsModalOpen(false)}
            >
              Fechar
            </Button>

            <Button
              variant="primary"
              onClick={() => handleModalSubmit()}
              disabled={isProductsLoading}
            >
              {isProductsLoading ? 'Carregando...' : 'Gerar Relatório'}
            </Button>
          </Modal.Footer>
        </Modal>

        {error && <div>Erro: {error.message}</div>}
      </div>

      <ProductModal
        show={showComposicao}
        handleClose={() => setShowComposicao(false)}
        composicao={composicao}
      />
    </div>
  )
}
